import React from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import useBelowBreakpoint from "core-web/hooks/useBelowBreakpoint";
import formatDate, { formatRelativeTime } from "core-web/utils/formatDate";
import transformFlexibleBackground from "theme/libs/wordpress/utils/transformFlexibleBackground";
import ArticleDefaultHeroBlock from "theme/libs/wordpress/content/cmsBlocks/ArticleDefaultHeroBlock";
import { useTranslation } from "react-i18next";

const ArticleHeroModule = ({ content }) => {
    const isMobile = useBelowBreakpoint("tabletLg");
    const locale = useSelector(({ application }) => application.locale);
    const { t } = useTranslation();
    const pageData = useSelector(({ page }) => page?.data) || {};
    const breadcrumbs = [{ permalink: "/", title: t("breadcrumbs.home") }];

    const title = pageData?.title;

    if (pageData?.parent) {
        breadcrumbs.push({ permalink: pageData.parent.permalink, title: pageData.parent.title });
    }
    breadcrumbs.push({ permalink: null, title });
    const primaryCategory = pageData?.primary_category?.name;
    const createdAt = pageData?.created_at;

    let createdShort = null;
    let publishedAgo = null;
    if (createdAt) {
        try {
            const date = new Date(`${createdAt.replace(" ", "T")}Z`);
            createdShort = formatDate(date, "d/M/yyyy", locale);
            publishedAgo = formatRelativeTime(date, locale);
        } catch (e) {
            createdShort = createdAt;
        }
    }

    const category = primaryCategory || null;

    const moduleContent = content?.data ?? content;
    const { background: backgroundObject, heading: headingObj, paragraph } = moduleContent || {};

    const device = headingObj?.customize_mobile && isMobile ? "mobile" : "desktop";
    const rawHeading = headingObj?.data?.[device]?.heading ?? headingObj?.data?.desktop?.heading;
    const headingText =
        title || (typeof rawHeading === "string" ? rawHeading : rawHeading?.text || rawHeading?.heading);

    const transformedBackground = transformFlexibleBackground(backgroundObject, "image");
    const desktopBg = transformedBackground?.desktop;
    const mobileBg = transformedBackground?.mobile;
    const desktopUrl = desktopBg?.url;
    const mobileUrl = mobileBg?.url;

    return (
        <ArticleDefaultHeroBlock
            breadcrumbs={breadcrumbs}
            createdShort={createdShort}
            category={category}
            publishedAgo={publishedAgo}
            headingText={headingText}
            paragraph={paragraph}
            desktopUrl={desktopUrl}
            mobileUrl={mobileUrl}
        />
    );
};

ArticleHeroModule.propTypes = {
    content: PropTypes.shape({
        background: PropTypes.object,
        heading: PropTypes.object,
        paragraph: PropTypes.array,
    }),
};

ArticleHeroModule.defaultProps = {
    content: {},
};

export default ArticleHeroModule;
